import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Resources from './pages/Resources';
import ReviewPage from './pages/ReviewPage';

// Article Pages
import BdnfBreakthrough from './pages/articles/BdnfBreakthrough';
import AudioEntrainment from './pages/articles/AudioEntrainment';
import CognitiveLongevity from './pages/articles/CognitiveLongevity';

import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-slate-50 flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resources" element={<Resources />} />
            
            {/* Article Routes */}
            <Route path="/resources/bdnf-breakthrough" element={<BdnfBreakthrough />} />
            <Route path="/resources/audio-entrainment" element={<AudioEntrainment />} />
            <Route path="/resources/cognitive-longevity" element={<CognitiveLongevity />} />
            
            <Route path="/review/the-brain-song" element={<ReviewPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;